export const FETCH_TELECONSEILLERS_REQUEST = 'FETCH_TELECONSEILLERS_REQUEST';
export const FETCH_TELECONSEILLERS_SUCCESS = 'FETCH_TELECONSEILLERS_SUCCESS';
export const FETCH_TELECONSEILLERS_FAILURE = 'FETCH_TELECONSEILLERS_FAILURE';

export const CREATE_TELECONSEILLER_REQUEST = 'CREATE_TELECONSEILLER_REQUEST';
export const CREATE_TELECONSEILLER_SUCCESS = 'CREATE_TELECONSEILLER_SUCCESS';
export const CREATE_TELECONSEILLER_FAILURE = 'CREATE_TELECONSEILLER_FAILURE';

export const DELETE_TELECONSEILLER_REQUEST = 'DELETE_TELECONSEILLER_REQUEST';
export const DELETE_TELECONSEILLER_SUCCESS = 'DELETE_TELECONSEILLER_SUCCESS';
export const DELETE_TELECONSEILLER_FAILURE = 'DELETE_TELECONSEILLER_FAILURE';

export const UPDATE_TELECONSEILLER_REQUEST = 'UPDATE_TELECONSEILLER_REQUEST';
export const UPDATE_TELECONSEILLER_SUCCESS = 'UPDATE_TELECONSEILLER_SUCCESS';
export const UPDATE_TELECONSEILLER_FAILURE = 'UPDATE_TELECONSEILLER_FAILURE';

export const UPDATE_TELECONSEILLER_SECURITY_REQUEST = 'UPDATE_TELECONSEILLER_SECURITY_REQUEST';
export const UPDATE_TELECONSEILLER_SECURITY_SUCCESS = 'UPDATE_TELECONSEILLER_SECURITY_SUCCESS';
export const UPDATE_TELECONSEILLER_SECURITY_FAILURE = 'UPDATE_TELECONSEILLER_SECURITY_FAILURE';

export const RESET_PASSWORD_REQUEST = "RESET_PASSWORD_REQUEST";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILURE = "RESET_PASSWORD_FAILURE";

export const SET_TELECONSEILLER_FILTER = 'SET_TELECONSEILLER_FILTER';